// extracted by mini-css-extract-plugin
module.exports =  {"actions":"C7pvvY","footerDivider":"wbg34L"};